module.exports = __webpack_public_path__ + "static/img/warehouse3.b01c100.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/warehouse3.png
// module id = smnW
// module chunks = 1